import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetUser = ()  => {
    const api = useApi();

    const mutate = async (param) => {
        const data  = await api.get(`/usuarios/one?username=${param}`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getUserMutation: mutation.mutate,
    };
}